import React, { Component } from "react";


class Screenshot extends Component { 
    render(){
        return (
            <div className="screenshot-area pt--120" id="screenshots">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb--80">
                                <h2>CAPTURAS DE <span className="theme-color">PANTALLA</span></h2>
                                <img className="image-1" src={require('../assets/images/app/title-icon-2.png')} alt="App Landing"/>
                                <img className="image-2" src={require('../assets/images/app/title-icon.png')} alt="App Landing"/>
                                <img className="image-3" src={require('../assets/images/app/title-icon-3.png')} alt="App Landing"/>
                                <p>Descubre la interfaz intuitiva de Mapptrix, diseñada para agricultores y profesionales del campo. Visualiza tus terrenos, gestiona cultivos y accede a herramientas de mapeo avanzadas desde cualquier lugar.</p>
                            </div>
                        </div>
                        <div className="col-lg-10 offset-lg-1">
                            <div className="screenshot-carousel" id="screenshot-carousel" data-carousel-3d>
                                <img className="image-1" src={require('../assets/images/app/screenshot-1.png')} alt="App Screenshot 1"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-2.png')} alt="App Screenshot 2"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-3.png')} alt="App Screenshot 3"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-4.png')} alt="App Screenshot 4"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-1.png')} alt="App Screenshot 5"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-2.png')} alt="App Screenshot 6"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-3.png')} alt="App Screenshot 7"/>
                                <img className="image-1" src={require('../assets/images/app/screenshot-4.png')} alt="App Screenshot 8"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Screenshot;










